import { RootState } from '../index';
export const getAuthToken = (state: RootState) => {
  return state.auth.token;
};
